import Vue from 'vue'
import VueRouter from 'vue-router'
// import LastWeek from '../views/LastWeek.vue'
// import All from '../views/All.vue'
// import Manager from '../views/Manager.vue'
import Index from '../views/Index.vue'
// import UserInfo from '../views/UserInfo.vue'
// import Moniter from '../views/Moniter.vue'

import NotFoundPage from '../views/NotFoundPage.vue'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Index',
    component: Index
  },
  {
    path: '/*',
    name: "404 NOT FOUND",
    component: NotFoundPage,
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
export default router
